import { useCallback, useEffect } from 'react'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import { setIsEscapingEditMode, setIsInEditMode } from '../SpreadSheetDataProvider/actions'
import ShortcutManager from 'Services/ShortcutManager'

BaseEdittingCellWithChars = ({ defaultValue, setValue, children }) ->

  value = (
    if _.isObject(defaultValue)
      '{ object }'
    else
      defaultValue or ''
  )

  [{
    isEscapingEditMode,
    isInEditMode,
  }, dispatch] = useSpreadSheetData()

  handleUserKeyPress = useCallback(({ key }) ->
    unless key in ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Escape', 'Meta', 'Control', 'Shift', 'Enter']
      setValue('')
      dispatch(setIsInEditMode(true))
      dispatch(setIsEscapingEditMode(false))
      window.removeEventListener('keydown', handleUserKeyPress)
  , [])

  useEffect( ->
    window.addEventListener('keydown', handleUserKeyPress)
    ->
      window.removeEventListener('keydown', handleUserKeyPress)
      dispatch(setIsInEditMode(false)) if isInEditMode
      ShortcutManager.blacklistShortcut('left', 'right')
  , [handleUserKeyPress])

  if isInEditMode
    children

  else
    <div
      onDoubleClick={(e) ->
        # go into edit mode
        e.persist()
        window.removeEventListener('keydown', handleUserKeyPress)
        dispatch(setIsInEditMode(true))
        dispatch(setIsEscapingEditMode(false))
        ShortcutManager.blacklistShortcut('left', 'right', 'up', 'down')
        e.preventDefault()
      }
    >
      { value }
    </div>

export default BaseEdittingCellWithChars
